/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SharedItemTile_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRelatedItems_searchBrowse$ref: FragmentReference;
export type SbSharedRelatedItems_searchBrowse = {|
  +relatedItems: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +serviceId: ?string,
        +$fragmentRefs: SharedItemTile_item$ref,
      |}
    |}>
  |},
  +$refType: SbSharedRelatedItems_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRelatedItems_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "relatedItems",
      "name": "thinBrowseRelatedItems",
      "storageKey": "thinBrowseRelatedItems(first:12,seller:\"INCLUDE\")",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 12,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "seller",
          "value": "INCLUDE",
          "type": "seller"
        }
      ],
      "concreteType": "searchBrowseMoreLikeThisConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "searchBrowseMoreLikeThisEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "SharedItemTile_item",
                  "args": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4c8631cfbe96378c8a00c7a800563422';
module.exports = node;
